// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
export enum StatusLive {
  before = 0,
  live = 1,
  after = 2,
  offCam = 4,
  pause = 5,
  error = 6,
  quit = 6,
}
export default StatusLive;
